module.exports = __webpack_public_path__ + "img/e591a65.jpg";